import { useCallback } from 'react'

import { firestore } from 'services/firebase'

const useGetUserByUid = () => {
  return useCallback(async (uid) => {
    return firestore
      .collection('users')
      .where('uid', '==', uid)
      .get()
      .then((snap) => {
        return snap.docs.map((item) => {
          return item.data()
        })
      })
  }, [])
}

export default useGetUserByUid
